import { SortList } from "./components/list/sortList";
import { Base } from "./sort.base";

export const ProductSort = Object.assign(Base, {
    List: SortList
});
